if (!customElements.get('ac-customer-reviews')) {
  customElements.define('ac-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('is-ready')) return;
      const button = this.querySelector('.ac-reviews__expand');
      if (button) {
        button.hidden = false;
        button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.less : button.dataset.more;
        });
      }
      this.classList.add('is-ready');
    }
  });
}
